module.exports = __webpack_public_path__ + "img/IMG_8157_L_Wood.fca650f5.jpg";